import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import FirstApprovalMessageConfirmationPopup from '../../../Components/FirstApprovalMessageConfirmationPopup'
import {
  useAdminUpdateSalesTypeMutation,
  useGetNotificationDetailQuery,
} from '../../../../services/cellcast'
import {toast} from 'react-toastify'

const UpdateSalesTypeApprovalPage = () => {
  const navigate = useNavigate()
  const {id} = useParams()
  const [message, setMessage] = useState('')
  const [approval, setAppoval] = useState(false)

  const [confirmPopup, setConfirmPopup] = useState(false)

  const {data: notificationData, isLoading} = useGetNotificationDetailQuery({id: id})

  const [updateSalesType] = useAdminUpdateSalesTypeMutation()

  useEffect(() => {
    if (approval) {
      const status = message?.includes('reject') ? 'rejected' : 'approved'

      updateSalesType({
        notificationId: notificationData?.data?._id,
        status: status,
      })
        .then((res: any) => toast.success(res.data.message))
        .finally(() => navigate('/dashboard'))
    }
  }, [approval, notificationData, message, navigate, updateSalesType])

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <>
      <FirstApprovalMessageConfirmationPopup
        show={confirmPopup}
        handleClose={() => setConfirmPopup(false)}
        message={message}
        setAllow={setAppoval}
      />
      <div className='card pt-4 pb-6 px-9 py-md-8 px-md-14 msg_approval'>
        <div className='card-header border-0 px-0'>
          <h3 className='card-title align-items-start flex-column me-5 mb-0'>
            {notificationData?.data?.message}
          </h3>
        </div>

        {notificationData?.data?.status === 'pending' ? (
          <>
            <div className='msg_btns'>
              <button
                value={'testing'}
                onClick={() => {
                  setMessage('Are you sure, you want to approve?')
                  setConfirmPopup(true)
                }}
                className='btn btn-primary m-5'
              >
                Approve
              </button>

              <button
                value={'reject'}
                onClick={() => {
                  setMessage('Are you sure, you want to reject?')
                  setConfirmPopup(true)
                }}
                className='btn btn-reject m-5'
              >
                Reject
              </button>
            </div>
          </>
        ) : (
          <div className='card-body'>
            <h3 className='card-title align-items-start flex-column me-5 mb-0'>
              Request has already been{' '}
              {notificationData?.data?.status === 'appproved' ? 'approved' : 'reject'}.
            </h3>
          </div>
        )}
      </div>
    </>
  )
}

export default UpdateSalesTypeApprovalPage
